import sizes from './devicesSizes';

export default {
  mobile: `(max-width: ${sizes.mobile})`,
  desktop: `(max-width: ${sizes.desktop})`,
};
